import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Pricing.css';
import IPricingProps from '../../domain/interfaces/components/IPricingProps';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt, faPlay, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import helpers from '../../util/helpers';
import { ServiceTypeEnum } from '../../domain/enums/ServiceTypeEnum';
import { getSalesmanagoOfferEvent } from '../../domain/utils';
import salesmanago from '../../services/external/salesmanago';
import { toast } from 'react-toastify';


type Subscription = {
  id: number;
  type: number;
  type_name: string;
  name: string;
  net_price: string;
  number_of_days: number;
  number_of_questions: number;
  subscriptions:
    | [
        {
          id: number;
          type: number;
          type_name: string;
          name: string;
          net_price: string;
          number_of_days: number;
          number_of_questions: number;
        }
      ]
    | null;
};

const Pricing: FC<IPricingProps> = (props): ReactElement => {
  const [selection, setSelection] = useState<string>('video');
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [isLoadingSubscriptions, setIsLoadingSubscriptions] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    fetch('https://api.pccporada.pl/v1/info/subscriptions')
      .then((response) => {
        setIsLoadingSubscriptions(true);
        return response.json();
      })
      .then((response) => setSubscriptions(response))
      .catch(() => {
        toast.error('Something happened when loading prices!');
      })
      .finally(() => setIsLoadingSubscriptions(false));
  }, []);

  const videos = subscriptions?.filter(
    (subscription) => subscription.type_name === 'video'
  );

  const consultancy = subscriptions?.filter(
    (subscription) => subscription.type_name === 'number_of_days'
  );

  const pricingData = {
    video: {
      1: {
        // total: videos[0]?.net_price ?? '',
        total: videos.find((v) => v.number_of_days === 5)?.net_price ?? '',
        perMonth: '',
        route: helpers.getVideoRoute(),
        benefits: [
          '5 dniowy dostęp nagranego szkolenia oraz',
          'Materiały szkoleniowe do pobrania',
          'Nagrania podzielone na bloki tematyczne'
        ]
      },
      2: {
        // total: videos[8]?.net_price ?? '',
        total: videos.find((v) => v.number_of_days === 30)?.net_price ?? '',
        perMonth: '',
        route: helpers.getVideoRoute(),
        benefits: [
          '30 dniowy dostęp nagranego szkolenia oraz',
          'Materiały szkoleniowe do pobrania',
          'Nagrania podzielone na bloki tematyczne'
        ]
      },
      3: {
        // total: videos[3]?.net_price ?? '',
        total: videos.find((v) => v.number_of_days === 90)?.net_price ?? '',
        perMonth: '',
        route: helpers.getVideoRoute(),
        benefits: [
          '90 dniowy dostęp do nagranego szkolenia oraz',
          'Materiały szkoleniowe do pobrania',
          'Nagrania podzielone na bloki tematyczne'
        ]
      },
      6: {
        // total: videos[2]?.net_price ?? '',
        total: videos.find((v) => v.number_of_days === 180)?.net_price ?? '',
        perMonth: '',
        route: helpers.getVideoRoute(),
        benefits: [
          '180 dniowy dostęp do nagranego szkolenia oraz',
          'Materiały szkoleniowe do pobrania',
          'Nagrania podzielone na bloki tematyczne'
        ]
      },
      12: {
        // total: videos[1]?.net_price ?? '',
        total: videos.find((v) => v.number_of_days === 365)?.net_price ?? '',
        perMonth: '',
        route: helpers.getVideoRoute(),
        benefits: [
          '365 dniowy dostęp do nagranego szkolenia oraz',
          'Materiały szkoleniowe do pobrania',
          'Nagrania podzielone na bloki tematyczne'
        ]
      }
    },
    consultancy: {
      // W przyszłości, zastanowić się nad tym, aby także zmienić sposób zaciągania się danych z api, dla konsultacji (przemyśleć podobny sposób, jak powyżej dla video, który jest bardziej elastyczny i jest mniej podatny na zmiany w api)
      7: {
          total: consultancy.find((c) => c.number_of_days === 7)?.net_price ?? consultancy[1]?.net_price ?? '',
          perMonth: (
            Number(consultancy.find((c) => c.number_of_days === 7)?.net_price ?? consultancy[1]?.net_price ?? 0)
          ).toFixed(2),
          route: helpers.getConsultationRoute(),
          nrQuestions: 'nielimitowane',
          benefits: [
            'Stały kontakt z Prelegentem',
            'Wzory dokumentów, orzecznictwa i wyroki sądowe',
            'Ciekawe przypadki i gotowe rozwiązania',
            'Odpowiedzi na najczęstsze pytania'
          ]
        },
      3: {
        total: consultancy[1]?.net_price,
        perMonth: (
          Number(consultancy[1]?.net_price) /
          Math.floor(consultancy[1]?.number_of_days / 30)
        ).toFixed(2),
        route: helpers.getConsultationRoute(),
        nrQuestions: 'nielimitowane',
        benefits: [
          'Stały kontakt z Prelegentem',
          'Wzory dokumentów, orzecznictwa i wyroki sądowe',
          'Ciekawe przypadki i gotowe rozwiązania',
          'Odpowiedzi na najczęstsze pytania'
        ]
      },
      6: {
        total: consultancy[0]?.net_price,
        perMonth: (
          Number(consultancy[0]?.net_price) /
          Math.floor(consultancy[0]?.number_of_days / 30)
        ).toFixed(2),
        route: helpers.getConsultationRoute(),
        nrQuestions: 'nielimitowane',
        benefits: [
          'Stały kontakt z Prelegentem',
          'Wzory dokumentów, orzecznictwa i wyroki sądowe',
          'Ciekawe przypadki i gotowe rozwiązania',
          'Odpowiedzi na najczęstsze pytania'
        ]
      },
      12: {
        total: consultancy[2]?.net_price,
        perMonth: (
          Number(consultancy[2]?.net_price) /
          Math.floor(consultancy[2]?.number_of_days / 30)
        ).toFixed(2),
        route: helpers.getConsultationRoute(),
        nrQuestions: 'nielimitowane',
        benefits: [
          'Stały kontakt z Prelegentem',
          'Wzory dokumentów, orzecznictwa i wyroki sądowe',
          'Ciekawe przypadki i gotowe rozwiązania',
          'Odpowiedzi na najczęstsze pytania'
        ]
      }
    }
  };

  // const renderPricingRow = (months: number, type: string = 'video') => {
  //   let wrapperClassName = 'pricing-table-row text-center position-relative';
  //   let buyNowStyle = 'btn-dark-blue';
  //   let route = pricingData[type][months].route;
  //   let header = t(`components.pricing.${type}_${months}_months_header`);
  //   let price = `${pricingData[type][months].total} zł + 23% VAT *`;
  //   let benefits = pricingData[type][months].benefits;
  //   //let msgSubscription = t(`components.pricing.${type}_${months}_months_msg`);
  //   let valuePerMonth = `${pricingData[type][months].perMonth} ${t(
  //     'components.pricing.per_month'
  //   )}`;

  //   let extraInfo = 'pakiet na';

  //   if (type === 'video') {
  //     valuePerMonth = price;
  //     price = '';
  //     extraInfo = '';
  //   }

  //   switch (months) {
  //     case 3:
  //       break;
  //     case 6:
  //       wrapperClassName += ' best-price';
  //       buyNowStyle += ' btn-best-price';

  //       break;
  //     case 12:
  //       break;
  //     default:
  //       break;
  //   }

  //   return (
  //     <Col key={months} md={4} className="p-3">
  //       <div className={wrapperClassName}>
  //         {months === 6 && (
  //           <span className="price-row-best-price-label">
  //             {t('components.pricing.best_price_label')}
  //           </span>
  //         )}

  //         <p className="pricing-row-per-month mb-3">{valuePerMonth}</p>
  //         <p className="pricing-row-price" style={{ marginBottom: -5 }}>
  //           {extraInfo}
  //         </p>
  //         <p className="pricing-row-header mb-3">{header}</p>
  //         <p className="pricing-row-price mb-3">{price}</p>
  //         {/* <p className='pricing-row-access mb-3'>{msgSubscription}</p> */}

  //         <div className="d-flex flex-column mb-5 flex-grow-1">
  //           {benefits.map((value: string, index: number) => (
  //             <p key={index} className="pricing-row-feature mb-3">
  //               {value}
  //             </p>
  //           ))}
  //         </div>

  //         <div>
  //           <Button className={buyNowStyle} href={route}>
  //             {t('components.pricing.details_btn_label')}
  //           </Button>
  //         </div>
  //       </div>
  //     </Col>
  //   );
  // };

  const renderPricingRow = (months: number, type: string = 'video') => {
    let wrapperClassName = 'pricing-table-row text-center position-relative';
    let buyNowStyle = 'btn-dark-blue';
    let route = pricingData[type][months].route;
    let header = t(`components.pricing.${type}_${months}_months_header`);
    let price = `${pricingData[type][months].total} zł + 23% VAT *`;
    let benefits = pricingData[type][months].benefits;
    
    const unitLabel = (type === 'consultancy' && months === 7)
      ? t('components.pricing.per_week')
      : t('components.pricing.per_month');

    let valuePerMonth = `${pricingData[type][months].perMonth} ${unitLabel}`;
    let extraInfo = 'pakiet na';

    if (type === 'video') {
      valuePerMonth = price;
      price = '';
      extraInfo = '';
    }

    // Wyróżnienie: 2 dla Nagrań, 3 dla Porad
    const isBestPrice = (type === 'video' && months === 2) || (type === 'consultancy' && months === 3);
    const isNewOffer = type === 'consultancy' && months === 7;

    if (isBestPrice) {
      wrapperClassName += ' best-price';
      buyNowStyle += ' btn-best-price';
    }

    return (
      <Col key={months} className="p-2 p-xl-2 mb-4 d-flex">
        <div className={wrapperClassName}>
          {/* Etykieta Najczęściej Wybierane (Poprawiony warunek na isBestPrice) */}
          {isBestPrice && (
            <span className="price-row-best-price-label">
              {t('components.pricing.best_price_label')}
            </span>
          )}

          {/* Propozycja: Badge NOWOŚĆ dla pakietu 7 dni */}
          {isNewOffer && (
            <span className="price-row-new-label">
              NOWOŚĆ
            </span>
          )}

          <p className="pricing-row-per-month mb-3">{valuePerMonth}</p>
          <p className="pricing-row-price" style={{ marginBottom: -5 }}>
            {extraInfo}
          </p>
          <p className="pricing-row-header mb-3">{header}</p>
          <p className="pricing-row-price mb-3">{price}</p>

          <div className="d-flex flex-column mb-5 flex-grow-1 px-2 px-xl-1 mt-3">
            {benefits.map((value: string, index: number) => (
              <div key={index} className="d-flex align-items-start mb-3 text-start">
                <FontAwesomeIcon 
                  icon={faCheckCircle} 
                  className="mt-1 me-2" 
                  style={{ color: '#2ecc71', fontSize: '1.1rem' }}
                />
                <p className="pricing-row-feature mb-0 text-start" style={{ textAlign: 'left' }}>
                  {value}
                </p>
              </div>
            ))}
          </div>

          <div>
            <Button className={buyNowStyle} href={route}>
              {t('components.pricing.details_btn_label')}
            </Button>
          </div>
        </div>
      </Col>
    );
  };

  const selectHandler = (value: string) => {
    if (selection !== value) {
      setSelection(value);

      salesmanago.createExternalEvent({
        ...getSalesmanagoOfferEvent({
          description: value
        })
      });
    }
  };

  return (
    <Col id="cennik">
      <Container style={{ paddingTop: 100, paddingBottom: 100 }}>
        <Row>
          <h4 className="pricing-title text-center">
            {t('components.pricing.title')}
          </h4>
          <p className="pricing-subtitle text-center">
            {t('components.pricing.subtitle')}
          </p>
        </Row>

        {/* <Row className="px-3 justify-content-center">
          <Col className="pricing-selector mt-4 mb-5 flex-grow-0 px-0">
            <div
              className={`pricing-inner-selector${
                selection === 'video' ? ' active' : ''
              }`}
              onClick={() => selectHandler('video')}
            >
              <FontAwesomeIcon icon={faPlay} size="2x" />
              <span className="ms-3">
                {t('components.pricing.selector_video')}
              </span>
            </div>
            <div
              className={`pricing-inner-selector${
                selection === 'consultancy' ? ' active' : ''
              }`}
              onClick={() => selectHandler('consultancy')}
            >
              <FontAwesomeIcon icon={faCommentAlt} size="2x" />
              <span className="ms-3">
                {t('components.pricing.selector_consultancy')}
              </span>
            </div>
          </Col>
        </Row> */}

        <Row className="px-3 justify-content-center">
          <Col className="mt-4 mb-5 flex-grow-0 px-0">
            {/* 1. Nadrzędny kontener - klasa 'consultancy-active' steruje przesunięciem tła */}
            <div className={`pricing-selector ${selection === 'consultancy' ? 'consultancy-active' : ''}`}>
              
              {/* 2. Animowane tło - ten element przesuwa się w lewo i prawo za pomocą CSS */}
              <div className="pricing-slider-bg"></div>
              <div
                className={`pricing-inner-selector ${selection === 'video' ? 'active' : ''}`}
                onClick={() => selectHandler('video')}
              >
                <FontAwesomeIcon icon={faPlay} size="1x" />
                <span className="ms-2">
                  {t('components.pricing.selector_video')}
                </span>
              </div>
              <div
                className={`pricing-inner-selector ${selection === 'consultancy' ? 'active' : ''}`}
                onClick={() => selectHandler('consultancy')}
              >
                <FontAwesomeIcon icon={faCommentAlt} size="1x" />
                <span className="ms-2">
                  {t('components.pricing.selector_consultancy')}
                </span>
              </div>
            </div>
          </Col>
        </Row>

        {!isLoadingSubscriptions && (
          <Row className="justify-content-center align-items-stretch row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5">
            {(selection === 'consultancy' ? [7, 3, 6, 12] : [1, 2, 3, 6, 12])
              .filter((key) => pricingData[selection][key] !== undefined)
              .map((value) => renderPricingRow(value, selection))}
          </Row>
        )}

        

        {isLoadingSubscriptions && (
          <Row className="justify-content-center">
            {[...Array(3)].map((_, i) => (
              <Col md={4} key={i} className="p-3">
                <div className="skeleton-pricing" />
              </Col>
            ))}
          </Row>
        )}

        <p style={{ marginTop: 30 }} className="pricing-vat-info text-center">
          {/* {t('components.pricing.vat_info')} */}
          {t('components.pricing.price_tax_description', {
            vatRule: helpers.getVatRule(
              selection === 'consultancy'
                ? ServiceTypeEnum.CONSULTANCY
                : ServiceTypeEnum.VIDEO
            )
          })}
        </p>
      </Container>
    </Col>
  );
};

export default Pricing;
